import script from "./alertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./alertModal.vue?vue&type=script&setup=true&lang=js"

import "./alertModal.vue?vue&type=style&index=0&id=2149e01c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2149e01c"]])

export default __exports__